import React, { useEffect, useState } from 'react';
import HeaderComponent from '../components/headerComponent';
import FooterComponent from '../components/footerComponent';
import { useI18n } from 'react-simple-i18n';
import { useLocation } from 'react-router-dom';
import appstate from '../appstate';
import { ArrowDownComponent } from '../components/arrowDownComponent';

function Intro(props: { hideAnimation: boolean; animationDone: boolean }) {
	const { t } = useI18n();

	const isMd = window.innerWidth < 768;

	// reactive boolean
	const [tick, setTick] = useState(false);

	// tick is a boolean that is set to true after initial render
	useEffect(() => {
		setTick(true);
	}, []);

	return (
		<>
			<div
				className={`fixed w-full top-0 left-0 z-60 transition-all duration-1000 h-screen ${
					props.hideAnimation && 'pointer-events-none'
				}`}
			>
				{/* Background */}
				<div
					className={`w-full h-full opacity-100 bottom-0 masked ${
						props.hideAnimation && 'hide'
					}`}
				>
					{/* Caption */}
					<div className={''}>
						<div
							className={`left-0 z-70 text-accent-200 text-4xl w-screen text-center transition delay-100 duration-500 px-6 md:px-12 ${
								tick
									? props.hideAnimation
										? 'opacity-0'
										: 'opacity-100'
									: 'opacity-0'
							}`}
							style={{
								textAlign: 'center',
								paddingTop:
									document.getElementById('ddt')?.offsetTop +
									'px',
								fontWeight: 'bold',
								// paddingRight: '2.12em',
								position: 'sticky',
								display: 'block',
							}}
						>
							{t('home.caption')}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default function DefaultNoKazaloLayout(props: any) {
	const [hideAnimation, setHideAnimation] = useState(false);
	const { pathname } = useLocation();

	const getIntroDuration = () => {
		const isMobile = window.innerWidth < 1024;

		if (isMobile || pathname !== '/' || appstate.debug) {
			return 100;
		}

		const introPlayDate = localStorage.getItem('introPlayDate');

		if (introPlayDate) {
			// Check if difference between current date and introPlayDate is greater than 1 hour
			const diff =
				new Date().getTime() - new Date(introPlayDate).getTime();
			return diff > 3600000 ? 1500 : 1000;
		}

		return 1300;
	};

	const [noTransform, setNoTransform] = useState(false);

	useEffect(() => {
		// LANGUAGE
		const url = new URL(window.location.href);
		const lang = url.searchParams.get('lang');
		if (lang) {
			if (localStorage.getItem('language') !== lang) {
				localStorage.setItem('language', lang);
				window.location.replace(window.location.href);
			}
		}

		// OTHER
		document.body.classList.add('no-scroll');

		const introDuration = getIntroDuration();

		setTimeout(() => {
			document.body.classList.remove('no-scroll');
			setHideAnimation(true);

			if (introDuration > 0) {
				localStorage.setItem('introPlayDate', new Date().toString());
			}
		}, introDuration);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setNoTransform(true);
		}, getIntroDuration() * 2);
	});

	// ADD LANGUAGE TO THE URL EVERY TIME THE ROUTE CHANGES
	useEffect(() => {
		const url = new URL(window.location.href);
		url.searchParams.set('lang', appstate.currentLanguage());
		window.history.replaceState({}, '', url.href);
	}, [
		// on route change
		pathname,
	]);

	// layout: max-w-8xl px-6 md:px-12 mx-auto

	return (
		<>
			<Intro animationDone={false} hideAnimation={hideAnimation} />
			<HeaderComponent />
			<div
				className={`flex flex-col ${
					!noTransform && 'transform'
				} origin-top transition duration-700 pt-8`}
			>
				<div className={'flex-1'}>{props.children}</div>
			</div>
			<FooterComponent />
		</>
	);
}
